import { UnitSystem } from '@ravago/shared/page-data/models/config';

import { parseAsInteger, parseAsStringLiteral, parseAsString } from 'nuqs/server';

import {
   parseAsCountryFacetTerms,
   parseAsDefaultFacetTerms,
   parseAsNestedFacetTerms,
   parseAsRangeFacetTerms,
   parseAsTab
} from './facet-nuqs-parsers';

export const paginationQueryParsers = {
   page: parseAsInteger.withDefault(1),
   tab: parseAsTab.withDefault('product')
};

export const createProductQueryParsers = (defaultCountry: string | undefined, defaultUnitSystem: UnitSystem) => ({
   ...paginationQueryParsers,
   search: parseAsString.withDefault(''),
   view: parseAsStringLiteral(['grid', 'list']).withDefault('grid'),
   unitSystem: parseAsStringLiteral(['SI', 'US']).withDefault(defaultUnitSystem).withOptions({ clearOnDefault: false }),
   country: parseAsCountryFacetTerms.withDefault(defaultCountry ? [{ key: defaultCountry }] : []),
   brand: parseAsDefaultFacetTerms.withDefault([]),
   producer: parseAsDefaultFacetTerms.withDefault([]),
   group: parseAsDefaultFacetTerms.withDefault([]),
   subgroup: parseAsDefaultFacetTerms.withDefault([]),
   quality: parseAsDefaultFacetTerms.withDefault([]),
   feature: parseAsDefaultFacetTerms.withDefault([]),
   visibility: parseAsDefaultFacetTerms.withDefault([]),
   industry: parseAsDefaultFacetTerms.withDefault([]),
   'processing-method': parseAsDefaultFacetTerms.withDefault([]),
   'sustainability-group': parseAsDefaultFacetTerms.withDefault([]),
   'flame-rating': parseAsNestedFacetTerms.withDefault([]),
   segment: parseAsNestedFacetTerms.withDefault([]),
   'sub-sustainability': parseAsNestedFacetTerms.withDefault([]),
   filler: parseAsRangeFacetTerms.withDefault([]),
   density: parseAsRangeFacetTerms.withDefault([]),
   'flow-rate': parseAsRangeFacetTerms.withDefault([]),
   'notched-impact': parseAsRangeFacetTerms.withDefault([]),
   'notched-impact-strength': parseAsRangeFacetTerms.withDefault([])
});
